export default __webpack_public_path__ + "static/media/04AW1-4AUG66.7101a295.jpg";